import { PrimitiveProps } from '@react-three/fiber';
import {
  type BufferGeometry,
  type MeshBasicMaterial,
  MeshLambertMaterial,
  Object3D,
  Vector3,
} from 'three';
import { GLTF } from 'three-stdlib';

import { usePreloadStore } from 'state/preloadStore';

interface TileProps extends Omit<PrimitiveProps, 'object' | 'position'> {
  uid: string;
  url: string;
  offset: Vector3;
}

class Tile extends Object3D {
  copyright: string | null = null;

  constructor(props: TileProps) {
    super();
    this.userData = { ...props.userData, uid: props.uid };

    const model = this.getModel(props.url);
    this.applyLambertMaterial(model);
    this.add(model.scene);

    this.position.copy(props.offset);
    this.copyright = model.asset.copyright ?? null;
  }

  private getModel(url: string): GLTF {
    const preloadedModels = usePreloadStore.getState().glTFs;
    return preloadedModels[url];
  }

  private applyLambertMaterial(model: GLTF) {
    model.scene.traverse(obj => {
      if ('material' in obj) {
        obj.material = new MeshLambertMaterial({
          map: (obj.material as MeshBasicMaterial).map,
        });
      }
      if ('geometry' in obj) {
        (obj.geometry as BufferGeometry).computeVertexNormals();
      }
    });
  }
}

export default Tile;
